import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";
import { authClient } from "../services/auth/authClient";
import i18n from "../config/languageInit";
const name = "auth";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
  var user = localStorage.getItem("jwtToken");
  var token = user;
  if (user) {
    user = jwtDecode(user);
    const tokenDate = new Date(user.exp * 1000);
    if (tokenDate <= new Date()) {
      localStorage.removeItem("jwtToken");
      window.location.href = "/";
    } else {
      user.token = token;
    }
  }
  return {
    user: user ? user : null,
    error: null,
    isMfa: false,
    isAuthenticated: user ? true : false,
    isLoading: false,
    roles: [],
  };
}

function createReducers() {
  return {
    logout,
    changeMfa,
    resetLogin,
  };

  function logout(state) {
    state.user = null;
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("aadToken");
    window.location.href = window.location.origin + "/";
  }

  function changeMfa(state) {
    state.isAuthenticated = false;
    state.isMfa = false;
  }

  function resetLogin() {
    localStorage.removeItem("jwtToken");
  }
}

function createExtraActions() {
  return {
    loginWithAad: loginWithAad(),
    refreshJwtByAad: refreshJwtByAad(),
  };

  function loginWithAad() {
    return createAsyncThunk(`${name}/log-in-aad`, ({ email, token }) =>
      authClient.post(`log-in-aad`, {
        email: email,
        token: token,
      })
    );
  }

  function refreshJwtByAad() {
    return createAsyncThunk(`${name}/refreshJwt`, ({ email, token }) =>
      authClient.post(`log-in-aad`, {
        email: email,
        token: token,
      })
    );
  }
}

function createExtraReducers() {
  return {
    ...loginWithAad(),
    ...refreshJwtByAad(),
  };

  function refreshJwtByAad() {
    var { pending, fulfilled, rejected } = extraActions.refreshJwtByAad;
    return {
      [pending]: (state) => {
        state.error = null;
        state.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        if (action.payload.data) {
          localStorage.setItem("jwtToken", action.payload.data.token);
        }

        const decodedToken = jwtDecode(action.payload.data.token);
        if (decodedToken.language_code) {
          i18n.changeLanguage(decodedToken.language_code);
        }

        state.isAuthenticated = true;
        state.isLoading = false;
        window.location.href = "/";
      },
      [rejected]: (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      },
    };
  }

  function loginWithAad() {
    var { pending, fulfilled, rejected } = extraActions.loginWithAad;
    return {
      [pending]: (state) => {
        state.error = null;
        state.isMfa = false;
        state.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        var azureToken = action.meta.arg.token;
        if (action.payload && azureToken) {
          localStorage.setItem("aadToken", azureToken);
          localStorage.setItem("jwtToken", action.payload.data.token);
        }

        const decodedToken = jwtDecode(action.payload.data.token);
        if (decodedToken.language_code) {
          i18n.changeLanguage(decodedToken.language_code);
        }

        state.isMfa = false;
        state.isAuthenticated = true;
        state.isLoading = false;
        window.location.href = "/";
      },
      [rejected]: (state, action) => {
        if (action.error.name === "TypeError") {
          state.error = {
            message:
              "Sistem genelinde bir hata oluştu. Lütfen Sistem Geliştirme Birimine bildiriniz.",
          };
        } else {
          state.error = action.error;
        }

        state.isLoading = false;
        state.isMfa = false;
      },
    };
  }
}
